<template>
  <v-card class="main-content-card" id="inte-intellectualCheck-card">
    <v-toolbar flat>
      <v-toolbar-title>知识产权申请审核</v-toolbar-title>
    </v-toolbar>
    <v-divider/>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12>
        <v-tooltip top>
          <v-chip small label class="mx-0" slot="activator"
                  :color="item.status.color"
                  @click="() => { history=item.history; hist = true; }">
            {{ item.status.name }}
          </v-chip>
          <span>点击查看审核历史</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { reviewDbid = item.dbid; reviewMsg = item.name; reviewActs = item.actions; review = true; }"
                 :disabled="reviewDisabled(item)">
            <v-icon color="teal">playlist_add_check</v-icon>
          </v-btn>
          <span>审核</span>
        </v-tooltip>
        <v-tooltip top>
        <v-btn icon class="mx-0" slot="activator"
               @click="onImport(item)"
               :disabled="!funcIds.includes('c_inteApp_imp')||  item.flag == '已导入' || !item.number || item.status.name =='已驳回'">
          <v-icon color="teal">publish</v-icon>
        </v-btn>
        <span>导入成果库</span>
      </v-tooltip>
        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="prev">
            <v-icon color="teal">publish</v-icon>
          </v-btn>
          <span>返回</span>
        </v-tooltip>
        <x-review
          v-model="review"
          :dbid="reviewDbid"
          :message="reviewMsg"
          :uri="uri"
          :actions="reviewActs"
          @ok="(it) => Object.assign(item,it)"
        />

        <x-history
          v-model="hist"
          :history="history"
          :status="statusItems"
        />
      </v-flex>

      <v-flex xs12>
        <basic :inteApp="item"/>
      </v-flex>
      <v-flex xs12>
        <app-manage :inteApp="item"/>
      </v-flex>
    </v-layout>
  </v-container>
  </v-card>
</template>

<script>
  import Vue from 'vue'
  import {mapGetters} from 'vuex'

  import Basic from './app/basic'
  import appManage from './appManage/manage'
  import XDelete from '@/components/global/Delete'
  import XReview from '@/components/global/Review'
  import XSubmit from '@/components/global/Submit'
  import XHistory from '@/components/global/History'

  const baseUri = '/api/inte/intellectualApp';
  const statusUri = '/api/code/status';

  export default {
    components: {XSubmit, XReview, XHistory, XDelete, Basic,appManage},

    data: () => ({
      uri: baseUri,
      item: {
        histories: [],
        status: {},
        actions: []
      },

      fileUri: '/api/inte/file',

      statusItems: [],

      review: false,
      reviewDbid: null,
      reviewMsg: null,
      reviewActs: [],

      hist: false,
      history: [],

      // 删除对话框
      dialogImp: false,
      impLoading: false,
      impDbid: '',

    }),

    // 路由进入前，组件就未完成渲染，不可以使用 this
    beforeRouteEnter(to, from, next) {
      window.console.log("In edit_page beforeRouteEnter");
      const dbid = to.params.dbid;

      if (dbid) {
        Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
            rsp => next(vm => {
              vm.dbid = dbid;
              vm.item = rsp.data;
              // 保存默认数据
              vm.defaultItem = window.xutil.clone(vm.item);
              vm.loading = false
            })
          )
      } else {
        next();
      }
    },

    // 路由改变前，组件就已经渲染完成，可以使用 this
    beforeRouteUpdate(to, from, next) {
      window.console.log("In edit_page beforeRouteUpdate");

      const dbid = to.params.dbid;
      if (dbid) {
        this.loading = true;
        Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
            rsp => {
              this.dbid = dbid;
              this.item = rsp.data;
              // 保存默认数据
              this.defaultItem = window.xutil.clone(this.item);
              this.loading = false;
              next()
            }
          )
      } else {
        next();
      }
    },

    computed: {
      ...mapGetters(['funcIds'])
    },

    created() {
      // 加载审核状态
      this.axios.get(statusUri, {params: {sort: 'rank.asc'}})
        .then(
          rspStaus => {
            this.statusItems = rspStaus.data.items;
          }
        )
    },

    methods: {
      reviewDisabled(item) {
        return !(
          // 当前用户拥有审核功能
          this.funcIds.includes('u_inteApp_review')
          // 并且，当前记录需要审核
          && item.actions.find(a => ['approve', 'return', 'revoke'].includes(a.action)))
      },
      onImport(item) {
        const vm = this;
        vm.impLoading = true;
        this.axios.post('/api/inte/intellectualApp/import', item).then( rsp => {
          this.item = rsp.data;
          // 保存默认数据
          this.defaultItem = window.xutil.clone(this.item);
          vm.loading = false;
        })
      },
      prev(){
        this.$router.go(-1)
      }
    }
  }
</script>
<style>
  div.dense table.datatable.table td:first-child,
  div.dense table.datatable.table td:not(:first-child),
  div.dense table.datatable.table th:first-child,
  div.dense table.datatable.table th:not(:first-child) {
    padding: 0 8px;
  }
</style>
